import { checkNull2String, getOnlyDate } from "./ItemTools"

export const JOB_STATUS_RESTART = "0"       //（未就業)新人、已離職、未報到
export const JOB_STATUS_RESERVE = "1"       //（預定上工中)預定中
export const JOB_STATUS_ONBOARD = "2"       //（就業中)已上工
export const JOB_STATUS_NOT_ONBOARD = "5"   //（就業中)已上工
export const JOB_STATUS_ALL = "6"           //（就業中)已上工

export const JOB_STATUS_RESTART_STRING = "未就業"
export const JOB_STATUS_RESERVE_STRING = "預定中"
export const JOB_STATUS_ONBOARD_STRING = "上工中"
export const JOB_STATUS_NAT_ONBOARD_STRING = "非就業中"
export const JOB_STATUS_ALL_STRING = "全部"

export const CASE_STATUS_START = 0      //已提交
export const CASE_STATUS_RESERVE = 1    //預定中
export const CASE_STATUS_CANCEL = 2     //未報到
export const CASE_STATUS_ONBOARD = 3    //已上工
export const CASE_STATUS_RESIGN = 4     //已離職
export const CASE_STATUS_INVALID = 5     //作廢

export const CASE_STATUS_START_STRING = "已提交"
export const CASE_STATUS_RESERVE_STRING = "預定中"
export const CASE_STATUS_ONBOARD_STRING = "已上工"
export const CASE_STATUS_CANCEL_STRING = "未報到"
export const CASE_STATUS_RESIGN_STRING = "已離職"
export const CASE_STATUS_INVALID_STRING = "作廢"

export const CASE_STATUS_START_SHORT_STRING = "提交"
export const CASE_STATUS_RESERVE_SHORT_STRING = "預定"
export const CASE_STATUS_ONBOARD_SHORT_STRING = "上工"
export const CASE_STATUS_CANCEL_SHORT_STRING = "未報到"
export const CASE_STATUS_RESIGN_SHORT_STRING = "離職"
export const CASE_STATUS_INVALID_SHORT_STRING = "作廢"

export const VIEW_CASESTATUS1 = 1   //預定中修正選單
export const VIEW_CASESTATUS2 = 2   //預定中修正選單
export const VIEW_CASESTATUS3 = 3   //預定中修正選單
export const VIEW_CASESTATUS4 = 4   //預定中修正選單
export const VIEW_RESERVEDATE = 5   //預定上工日
export const VEW_CASEOWNER = 6      //案件管轄者
export const VIEW_OVERDUE = 7       //逾期報到作業
export const VIEW_INVALID = 8       //作廢此 “派遣案件”
export const VIEW_CANCEL_TO_RESERVE = 9     //從“未報到” 改為 “預定中”
export const VIEW_ONBOARDDATE = 10   //修正“實際上工日”
export const VIEW_ONBOARD_TO_RESERVE = 11   //修正“實際上工日”
export const VIEW_RESIGNDATE = 12   //校正 “下工日”
export const VIEW_RESIGN_TO_ONBOARD = 13   //修正“實際上工日”

export class ReqRecruitmentContractorList {
    constructor({ companyId, departmentId, start, limit, nickName, idNumber, jobStatus }) {
        this.companyId = companyId
        this.departmentId = departmentId
        this.start = start
        this.limit = limit
        if (nickName !== undefined && nickName !== "") {
            this.nickName = nickName
        }
        if (idNumber !== undefined && idNumber !== "") {
            this.idNumber = idNumber
        }
        if (jobStatus !== undefined && jobStatus !== "") {
            this.jobStatus = jobStatus
        }
        if (departmentId !== undefined && departmentId !== "") {
            this.departmentId = departmentId
        }
    }

    fromJson(jsonData) {
        // this.companyId = jsonData.companyId
        // this.start = jsonData.start
        // this.limit = jsonData.limit
        if (jsonData.nickName !== undefined)
            this.nickName = jsonData.nickName
        if (jsonData.idNumber !== undefined)
            this.idNumber = jsonData.idNumber
        if (jsonData.jobStatus !== undefined)
            this.jobStatus = jsonData.jobStatus
        if (jsonData.departmentId !== undefined)
            this.departmentId = jsonData.departmentId
    }
}


export class ReqRecruitmentContractorAdd {
    constructor({ companyId, departmentId, caseContractor, caseStatus = 1, caseInfo, caseOwner }) {
        this.companyId = companyId              //公司
        this.departmentId = departmentId        //部門
        this.caseContractor = caseContractor    //案件對象
        this.caseStatus = caseStatus            //案件進行狀態
        this.caseInfo = caseInfo
        this.isClosed = 0                       //結案與否（作業進行狀態 3 or 4 相當於結案）
        this.isDelete = 0                       //是否刪除
        this.caseOwner = caseOwner              //案件管轄者(若2時=直屬專員）
    }

    fromJson(jsonData) {
        if (jsonData !== undefined) {
            this.companyId = jsonData.companyId
            this.departmentId = jsonData.departmentId
            this.caseContractor = jsonData.caseContractor
            this.caseStatus = jsonData.caseStatus
            this.caseInfo = jsonData.caseInfo
            this.isClosed = jsonData.isClosed
            this.isDelete = jsonData.isDelete
            this.caseOwner = jsonData.caseOwner
            this.creatAccountId = jsonData.creatAccountId
        }
    }
}

export class ReqRecruitmentContractorDetail {
    constructor({ companyId, accountId, tokenId }) {
        this.companyId = companyId
        this.accountId = accountId
        this.tokenId = tokenId
    }
}

export class RespRecruitmentContractorDetail {
    constructor({ recruitmentContractorId, companyId, departmentId, caseContractor, caseStatus = 1, caseInfo, isClosed, isDelete, isBlacklist, caseOwner, caseOwnerName, creatAccountId, creatAt }) {
        this.recruitmentContractorId = recruitmentContractorId
        this.companyId = companyId              //公司
        this.departmentId = departmentId        //部門
        this.caseContractor = caseContractor    //案件對象
        this.caseStatus = caseStatus            //案件進行狀態
        this.caseInfo = caseInfo
        this.isClosed = isClosed                       //結案與否（作業進行狀態 3 or 4 相當於結案）
        this.isDelete = isDelete                       //是否刪除
        this.isBlacklist = isBlacklist
        this.caseOwner = caseOwner              //案件管轄者(若2時=直屬專員）
        this.caseOwnerName = caseOwnerName      //案件管轄者姓名
        this.creatAccountId = creatAccountId
        this.creatAt = creatAt
    }

    fromJson(jsonData) {
        if (jsonData !== undefined) {
            this.recruitmentContractorId = jsonData.recruitmentContractorId
            this.companyId = jsonData.companyId
            this.departmentId = jsonData.departmentId
            this.caseContractor = jsonData.caseContractor
            this.caseContractorName = jsonData.caseContractorName
            this.caseContractorSex = jsonData.caseContractorSex
            this.caseContractorAge = jsonData.caseContractorAge
            this.caseContractorMobile = jsonData.caseContractorMobile
            this.caseStatus = jsonData.caseStatus
            this.caseInfo = new ReqRecruitmentContractorCaseInfo({})
            this.caseInfo.fromJson(jsonData.caseInfo)
            this.isClosed = jsonData.isClosed
            this.isDelete = jsonData.isDelete
            this.isBlacklist = jsonData.isBlacklist
            this.caseOwner = jsonData.caseOwner
            this.caseOwnerName = jsonData.caseOwnerName
            this.creatAccountId = jsonData.creatAccountId
            this.creatAt = jsonData.creatAt
        }
    }
}

export class ReqRecruitmentContractorCaseInfo {
    constructor({
        caseCreateDate = ""             //案件開始日期時間
        , caseReserveDate = ""          //到職日(內部)
        , customerPositionId = ""       //廠商職缺Id	
        , caseSignAt = ""               //簽約日期
        , caseCompanyName = ""          //廠商名稱
        , caseCustomerPosition = ""     //廠商職缺內容
        , caseWorkPlace = ""           //工作地點
        , caseWorkAddress = ""          //工作地址
        , caseProcessDescription = []   //作業內容描述-累加
        , caseComment = []              //評論描述-累加
        , caseCancelDate = ""           //未報到作業的日期
        , caseOnBoardDate = ""          //實際上工日期
        , caseResignDate = ""           //下工日
        , caseInvalidDate = ""          //作廢日期
    }) {
        this.caseCreateDate = caseCreateDate
        this.caseReserveDate = caseReserveDate
        this.customerPositionId = customerPositionId
        // this.caseContractorName = caseContractorName
        // this.caseSexAge = caseSexAge
        // this.caseMobile = caseMobile
        this.caseSignAt = caseSignAt
        this.caseCompanyName = caseCompanyName
        this.caseCustomerPosition = caseCustomerPosition
        this.caseWorkPlace = caseWorkPlace
        this.caseWorkAddress = caseWorkAddress
        this.caseProcessDescription = caseProcessDescription
        this.caseComment = caseComment
        this.caseCancelDate = caseCancelDate
        this.caseOnBoardDate = caseOnBoardDate
        this.caseResignDate = caseResignDate
        this.caseInvalidDate = caseInvalidDate
    }

    fromJson(jsonData) {
        if (jsonData === undefined || jsonData === null)
            return
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        // console.log(jsonData)
        this.caseCreateDate = jsonData.caseCreateDate || ""
        this.caseReserveDate = jsonData.caseReserveDate || ""
        this.customerPositionId = jsonData.customerPositionId || ""
        this.caseContractorName = jsonData.caseContractorName || ""
        // this.caseSexAge = jsonData.caseSexAge||""
        // this.caseSexAge = jsonData.caseSexAge||""
        // this.caseMobile = jsonData.caseMobile||""
        this.caseSignAt = jsonData.caseSignAt || ""
        this.caseCompanyName = jsonData.caseCompanyName || ""
        this.caseCustomerPosition = jsonData.caseCustomerPosition || ""
        this.caseWorkPlace = jsonData.caseWorkPlace || ""
        this.caseWorkAddress = jsonData.caseWorkAddress || ""
        this.caseProcessDescription = jsonData.caseProcessDescription !== undefined ? jsonData.caseProcessDescription : []
        this.caseComment = jsonData.caseComment !== undefined ? jsonData.caseComment : []
        this.caseCancelDate = jsonData.caseCancelDate || ""
        this.caseOnBoardDate = jsonData.caseOnBoardDate || ""
        this.caseResignDate = jsonData.caseResignDate || ""
        this.caseInvalidDate = jsonData.caseInvalidDate || ""
    }
}

export class ReqCaseInfoText {
    constructor({ id, name, text }) {
        this.id = id
        this.name = name
        this.text = text
    }

    fromJson(jsonData) {
        this.id = jsonData.id
        this.name = jsonData.name
        this.text = jsonData.text
    }
}